import React from 'react';
import { string } from 'prop-types';
import { ListItem, NavItem, Heading } from '@tesla/design-system-react';
import Styles from '../../SideNavigationBar.module.css.js';
import NavBarToolTip from '../NavBarToolTip.js';
import { useNavConfigContext } from '../../Context/index.js';

var CustomIconTab = function CustomIconTab() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = props.id,
    label = props.label,
    externalUrl = props.externalUrl,
    iconImageUrl = props.iconImageUrl;
  var _useNavConfigContext = useNavConfigContext(),
    translations = _useNavConfigContext.translations,
    isMobileView = _useNavConfigContext.isMobileView,
    onTabClick = _useNavConfigContext.onTabClick,
    activeTab = _useNavConfigContext.activeTab;
  if (!iconImageUrl) {
    return null;
  }
  var translatedLabel = translations ? translations(label) : label;
  var isSelected = activeTab ? label === activeTab : window.location.href.includes(externalUrl);
  var onClick = function onClick(event) {
    event.preventDefault();
    if (onTabClick) {
      onTabClick(props);
    } else {
      window.open(externalUrl, '_self');
    }
  };
  return /*#__PURE__*/React.createElement(ListItem, {
    key: id,
    id: id,
    "data-test": "custom-icon-tab"
  }, /*#__PURE__*/React.createElement(NavItem, {
    onClick: onClick,
    className: Styles['tw-react--side-nav-bar--tab--gap10'],
    startIcon: /*#__PURE__*/React.createElement(NavBarToolTip, {
      label: translatedLabel,
      iconImageUrl: iconImageUrl
    }),
    selected: isSelected
  }, isMobileView && /*#__PURE__*/React.createElement(Heading, {
    className: "tds--no_padding",
    is: "span",
    looksLike: "h4"
  }, translatedLabel)));
};
CustomIconTab.propTypes = {
  iconImageUrl: string,
  id: string.isRequired,
  label: string,
  externalUrl: string.isRequired
};
CustomIconTab.defaultProps = {
  iconImageUrl: '',
  label: ''
};

export { CustomIconTab as default };
